import React from 'react';
import { getCEPMask } from '../../utils/InputMaskUtils';
import MaskedInput from 'react-text-mask';

const CEPMaskedInput = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={getCEPMask()}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

export default CEPMaskedInput;
